import React from 'react';
import ReactDOM from 'react-dom';
import { MapContainer, TileLayer, Marker, Popup, Polyline, FeatureGroup, useMap, Tooltip } from 'react-leaflet'


class MapViewControl extends React.Component {
    constructor(props) {
        super(props);
        this.goToEvent = this.goToEvent.bind(this);
    }

    goToEvent(){    
        window.location.href = this.props.ride.Url;
    }

    render() {
        return (
            <div className="leaflet-top leaflet-right">
                <div className="leaflet-control leaflet-bar audax-sidebar col-12">
                    <h3>{this.props.ride.Name}</h3>
                    <button className="btn btn-primary btn-sm col-12" onClick={this.props.close}>Close</button>
                    <button className="btn btn-primary btn-sm col-12 mt-2" onClick={this.goToEvent}>Details</button>
                </div>
            </div>
        )
    }
}
export default MapViewControl;

